import styled from 'styled-components'

const Heading1 = styled.h1`
  margin-top: 0;
  font-size: 2.48rem;
  font-weight: bold;
  color: #333333;

  ${props =>
    props.big
      ? `
    font-size: 2.986rem;
    font-weight: 900;
    color: #1e1e1e;
    `
      : null};
  ${props =>
    props.huge
      ? `
      font-size: 3.583rem;
      font-weight: 900;
      color: #101010;
      `
      : null};

  @media only screen and (max-width: 450px) {
    font-size: 1.68rem;
  }
`
const Heading2 = styled.h2`
  margin-top: 0;
  font-size: 2.074rem;
  font-weight: bold;
  color: #363636;

  @media only screen and (max-width: 450px) {
    font-size: 1.44rem;
  }
`
const Heading3 = styled.h3`
  margin-top: 0;
  font-size: 1.728rem;
  font-weight: 600;
  color: #3a3a3a;

  @media only screen and (max-width: 450px) {
    font-size: 1.32rem;
  }
`

export { Heading1, Heading2, Heading3 }
